<template>
  <a-popover placement="bottomRight" overlayClassName="query-condition-filter-popover">
    <template #content>
      <a-list class="query-condition-filter" :data-source="fieldsOptions" size="small">
        <template #renderItem="{ item }">
          <a-list-item>
            <div class="query-condition-filter-item">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-checkbox"><a-switch :checked="fieldsCheckedMap[item.dataIndex]" @update:checked="v => changeItemSetting(item, v)" size="small"/></div>
            </div>
          </a-list-item>
        </template>
      </a-list>
    </template>
    <template #title>
      <span>选择查询条件</span>
    </template>
    <div class="query-condition-filter-icon">
      <dol-icon type="FilterOutlined"/>
    </div>
<!--    <a-badge :count="showQueryFieldsCount" size="small">-->
<!--    </a-badge>-->
  </a-popover>
</template>

<script>
export default {
  name: 'dol-query-form-filter',
  props: {
    fields: { type: Object, default: () => [] },
    showQueryFields: { type: Object, default: () => ({}) },
  },
  computed: {
    fieldsCheckedMap(){
      const map = {};
      this.fields.forEach(item => {
        if(typeof item.queryFilter === 'undefined') return true;

        if(typeof this.showQueryFields[item.dataIndex] === 'boolean'){
          map[item.dataIndex] = this.showQueryFields[item.dataIndex];
        }else{
          map[item.dataIndex] = item.queryFilter;
        }
      });
      return map;
    },
    fieldsOptions(){
      return this.fields.filter(item => !item.queryFixed && typeof item.queryFilter !== 'undefined');
    },
    showQueryFieldsCount(){
      return Object.values(this.fieldsCheckedMap).filter(v => v).length;
    },
  },
  data () {
    return {};
  },
  methods: {
    changeItemSetting(item, v){
      this.$emit('update:show-query-fields', {
        ...this.showQueryFields,
        [item.dataIndex]: v
      });
    }
  }
}
</script>

<style lang="scss">
@use "../../../assets/scss/constant" as constant;
.query-condition-filter-icon{
  width: 24px;
  height: 24px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;

  &:hover{
    color: constant.$primaryColor;
    //background: #F3F5F7;
  }
}
.query-condition-filter-popover{
  .ant-popover-title{
    margin-top: 5px;
    padding-left: 10px;
  }
}
.query-condition-filter{
  min-width: 200px;
  max-height: 400px;
  overflow: auto;
  .query-condition-filter-item{
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 12px;

    .item-title{
      flex: 1;
    }
  }
}
</style>
